<template>
  <div>
    <div class="row data-filter">
      <div class="col-7 row">
        <div class="col-5 mt-3">
          <div class="search-answers">
            <input
              type="text"
              class="form-control"
              id="input-answer"
              :placeholder="$t('answers.searchInput')"
              v-model="filter"
              @keyup="searchByFilter"
            />
            <button @click="cleanFilter" class="btn btn-outline-primary">
              {{ $t('answers.searchButton') }}
            </button>
          </div>
        </div>
        <div class="mt-3 ml-1 p-0">
          <b-form-select
            @change="handleFilter"
            v-model="filterSelected"
            :options="filterOptions"
          ></b-form-select>
        </div>
        <div v-if="displayFilterOptions" class="mt-3 ml-3 p-0">
          <b-form-select
            @change="handleFilterValue"
            v-model="filterValueSelected"
            :options="filterSelectedOptions"
          ></b-form-select>
        </div>
        <div
          v-if="filterSelected === 'category' && filterValueSelected !== null"
          class="mt-3 ml-3 p-0"
        >
          <b-form-select
            @change="handleFilterSubCategory"
            v-model="filterSubCategorySelected"
            :options="filterOptionsSubCategory"
          ></b-form-select>
        </div>
      </div>

      <div class="col-3">
        <p class="idx-bold mb-2">
          {{ $t('closetheloop.selectAnswers.closureType') }}
        </p>
        <div>
          <b-form-radio-group
            v-model="selected"
            :options="radioOptions"
            class="mb-3"
            value-field="item"
            text-field="name"
            disabled-field="notEnabled"
          ></b-form-radio-group>
        </div>
      </div>

      <div class="col-2">
        <div
          class="row col-12 mt-4"
          style="display: flex; justify-content: flex-end;"
        >
          <div class="custom-switch">
            <input
              type="checkbox"
              class="custom-control-input"
              id="switch-select-resend"
              v-model="pageSelected"
              :disabled="allAnswersSelected"
              @click="selectPage($event)"
            />
            <label class="custom-control-label" for="switch-select-resend" style="font-size: 16px; white-space: nowrap;">
              {{ $t('resend.selectPage') }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 filters-area">
        <div v-if="this.profileSelect.value" class="tag">
          <span>
            {{ $t('answers.filterOptions.profile') }}:
            {{ this.profileSelect.text }}
          </span>
          <span @click="removeFilter('profile')" class="remove">&times;</span>
        </div>
        <div v-if="this.statusSelect.value" class="tag">
          <span>
            {{ $t('answers.filterOptions.status') }}:
            {{ this.statusSelect.text }}
          </span>
          <span @click="removeFilter('status')" class="remove">&times;</span>
        </div>
        <div v-if="this.categorySelected.value" class="tag">
          <span>
            {{ $t('answers.filterOptions.category') }}:
            {{ this.categorySelected.text }}
          </span>
          <span @click="removeFilter('category')" class="remove">&times;</span>
        </div>
        <div v-if="this.subCategorySelected.value" class="tag">
          <span>
            SubCategoria:
            {{ this.subCategorySelected.text }}
          </span>
          <span @click="removeFilter('subCategory')" class="remove"
            >&times;</span
          >
        </div>
        <div v-if="this.responsibleSelected.value" class="tag">
          <span>
            {{ $t('answers.filterOptions.responsible') }}:
            {{ this.responsibleSelected.text }}
          </span>
          <span @click="removeFilter('responsible')" class="remove"
            >&times;</span
          >
        </div>
        <div v-if="this.commentSelected.value" class="tag">
          <span>
            {{ $t('answers.filterOptions.comments') }}:
            {{ this.commentSelected.text }}
          </span>
          <span @click="removeFilter('comment')" class="remove">&times;</span>
        </div>
        <div v-if="this.anonymousSelected.value" class="tag">
          <span>
            {{ this.$t('answers.filterOptions.anonymous') }}:
            {{ this.anonymousSelected.text }}
          </span>
          <span @click="removeFilter('anonymous')" class="remove">&times;</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div
        class="col-12"
        style="display: flex; flex-direction: row; justify-content: center;"
      >
        <transition name="fade">
          <div
            v-if="selectedAnswersIds.length > 0 || allAnswersSelected"
            class="select-all-area mb-3"
          >
            <div v-if="!allAnswersSelected" class="select-all-description">
              {{
                $t('closetheloop.selectAnswers.answersLength', {
                  length: selectedAnswersIds.length,
                })
              }}

              <span @click="selectAllAnswers" class="link idx-bold">
                {{ $t('closetheloop.selectAnswers.selectAll') }}
              </span>
            </div>

            <div v-else class="select-all-description">
              {{
                $t('closetheloop.selectAnswers.allSelected', {
                  totalAnswers: `${this.totalAnswers}`,
                })
              }}

              <span @click="cancelAnswersSelected" class="link idx-bold">
                {{ $t('closetheloop.selectAnswers.cleanSelection') }}
              </span>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <b-table
          striped
          @sort-changed="sortingChanged"
          no-local-sorting
          id="treatment-table"
          class="mt-3"
          :items="items"
          :fields="fields"
          :busy="$store.state.treatments.loading"
          responsive
        >
          <template v-slot:table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner type="grow" class="align-middle"></b-spinner>
            </div>
          </template>
          <!-- Ação -->
          <template v-slot:cell(actionId)="row">
            <span>{{ row.item.actionId.name }}</span>
            <br />
            <span class="user-info">
              {{ $t('answers.metric') }}:
              {{
                row.item.metric === 'nps-0-10'
                  ? 'NPS 0 a 10'
                  : row.item.metric === 'nps-1-5'
                  ? 'NPS 1 a 5'
                  : row.item.metric === 'ces-1-5'
                  ? 'CES 1 a 5'
                  : row.item.metric === 'CSAT 1 a 5'
                  ? 'CSAT 1 a 5(Top 2 box)'
                  : 'CSAT 1 a 5(Média)'
              }}
            </span>
          </template>
          <!-- Data -->
          <template v-slot:cell(date)="row">
            {{ dateFormat(new Date(row.item.date)) }}
          </template>
          <!-- Nota -->
          <template v-slot:cell(review)="row">
            <template v-if="row.item.metric === 'like-dislike'">
              <span v-if="row.item.review === 1">
                <img
                  alt="Like"
                  width="60"
                  height="60"
                  src="../../../../assets/Like.svg"
                />
              </span>
              <span v-if="row.item.review === 0">
                <img
                  alt="Like"
                  width="60"
                  height="60"
                  src="../../../../assets/Deslike.svg"
                />
              </span>
            </template>
            <template v-else>
              <div
                :class="`flag-grade flag-grade-${gradeFormat(row.item.review)}`"
              >
                <span v-if="row.item.review != '99'">{{
                  row.item.review
                }}</span>
                <span v-else>-</span>
              </div>
            </template>
          </template>
          <!-- Cliente -->
          <template v-slot:cell(name)="row">
            <span class="user-info">{{
              checkName(row.item.anonymousResponse, row.item.name)
            }}</span>
            <br />
            <span class="user-info">
              {{ $t('answers.email') }}:
              {{ checkUserData(row.item.anonymousResponse, row.item.email) }}
            </span>
            <br />
            <span class="user-info">
              {{ $t('answers.telephone') }}:
              {{ checkUserData(row.item.anonymousResponse, row.item.phone) }}
            </span>
          </template>
          <!-- Comment -->
          <template v-slot:cell(comment)="row">
            <div v-if="row.item.feedbackEdited.edition">
              {{ row.item.feedbackEdited.edition }}
              <span>
                <i
                  class="fas fa-pen ml-1"
                  style="font-size: 12px; color: #c1c1c1;"
                  :title="`${$t('answers.feedbackEdited', {
                    feedbackEditedAutor: `${row.item.feedbackEdited.author}`,
                  })}`"
                ></i>
              </span>
            </div>
            <div v-else>{{ row.item.feedback }}</div>
          </template>
          <!-- Categorias -->
          <template
            v-slot:cell(category)="row"
            :id="row.index"
            v-if="userProfile.permissions.treatments.category"
          >
            <div class="categories-area">
              <div
                v-for="(category, i) in row.item.categories"
                :key="i"
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                "
              >
                <idx-chips>
                  <span>{{ category.name }}</span>
                </idx-chips>

                <template
                  v-for="(subCategory, index) in row.item.subCategories"
                >
                  <idx-chips
                    v-if="subCategory.mainCategoryId === category._id"
                    :key="index"
                    :subCategory="true"
                    style="margin-left: 24px;"
                  >
                    <span>{{ subCategory.name }}</span>
                  </idx-chips>
                </template>
              </div>
            </div>
          </template>
          <!-- Enviar -->
          <template v-slot:cell(select)="row">
            <b-form-checkbox
              class="ml-3"
              :checked="verifyChecked(row.item._id) || allAnswersSelected"
              @change="selectAnswer(row.item._id, $event)"
              :disabled="allAnswersSelected"
            >
            </b-form-checkbox>
          </template>
        </b-table>
        <div class="footer" v-show="!loading">
          <div class="pagination-area-answers">
            <paginate
              v-model="page"
              :pageCount="Math.ceil(total / limit)"
              :clickHandler="updateTable"
              :prevText="'‹'"
              :nextText="'›'"
              :activeClass="'active'"
              :containerClass="'pagination b-pagination'"
              :pageClass="'page-item'"
            ></paginate>
          </div>
        </div>
        <div class="row">
          <div class="col-12 d-flex justify-content-end">
            <button
              v-if="!showModal"
              class="btn btn-info"
              @click="handleNextStep"
            >
              Próximo
            </button>

            <b-button
              v-if="showModal"
              class="btn btn-info"
              v-b-modal.modal-stauts
              >Próximo</b-button
            >

            <b-modal
              id="modal-stauts"
              title="Fechamento de tratativa em massa"
              @ok="makeDealings"
            >
              <p>
                Escolha abaixo qual será o status padrão após o fechamento em
                massa. Todos os
                <b>{{ this.selectedAnswersIds.length }} clientes </b>
                selecionados terão seus status alterados automaticamente.
              </p>

              <p class="mt-4 mb-2">
                Status:
              </p>
              <b-form-select
                v-model="status"
                :options="optionsStatus"
              ></b-form-select>

              <p class="mt-4 mb-2">Responsável:</p>
              <b-form-select
                v-model="responsibleModal"
                :options="responsibleOptions"
              ></b-form-select>

              <p class="mt-4 mb-2">Comentário:</p>
              <b-textarea
                id="textarea"
                v-model="comment"
                rows="3"
                max-rows="6"
              ></b-textarea>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert';
import Paginate from 'vuejs-paginate';
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { lightFormat } from 'date-fns';
import dashboardBar from '@/components/molecules/dashboard-bar';
import modalAddquestions from '@/components/molecules/modal-addquestions';
import api from '../../../../services/api';
import idxChips from '../../../molecules/idx-chips';
import EventBus from '../../../../eventBus';
import { lang } from 'moment';

export default {
  components: {
    dashboardBar,
    idxChips,
    modalAddquestions,
    Paginate,
  },

  data: () => ({
    displayFilterOptions: false,
    filterOptions: [
      { value: null, text: 'Escolha o filtro' },
      { value: 'profile', text: 'Perfil' },
      { value: 'status', text: 'Status' },
      { value: 'category', text: 'Categoria' },
      { value: 'responsible', text: 'Responsável' },
      { value: 'comment', text: 'Comentário' },
      { value: 'anonymous', text: 'Anônimo' },
    ],
    filterSelectedOptions: [],
    filterSelected: null,
    filterValueSelected: null,
    statusSelect: { value: null, text: null },
    profileSelect: { value: null, text: null },
    categorySelected: { value: null, text: null },
    responsibleSelected: { value: null, text: null },
    commentSelected: { value: null, text: null },
    anonymousSelected: { value: null, text: null },
    profileOptions: [],
    statusOptions: [],
    categoryOptions: [],
    responsibleOptions: [],
    commentOptions: [],
    anonymousOptions: [],
    selectedAnswersIds: [],
    itemsSelected: [],
    pageSelected: false,
    allAnswersSelected: false,
    userAuth: null,
    active: false,
    page: 1,
    limit: 10,
    options: [],
    fields: [],
    items: [],
    total: 0,
    filter: null,
    typingTimer: null,
    sortBy: null,
    sortDesc: null,
    grade: null,
    actionCategories: [],
    filterSubCategorySelected: null,
    filterOptionsSubCategory: [],
    subCategorySelected: { value: null, text: null },
    totalAnswers: 0,
    selected: 'email',
    radioOptions: [],
    showModal: false,
    optionsStatus: [],
    status: null,
    comment: null,
    anonymous: null,
    responsibleModal: null,
  }),

  computed: {
    ...mapState('treatments', ['loading', 'myStatus']),
    ...mapState('settings', ['companyCategories']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('authentication', ['userProfile']),
    ...mapFields('closetheloop', ['step', 'submitDone']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
    ...mapState('branches', ['ih1', 'ih2', 'myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
  },

  methods: {

    ...mapActions('treatments', ['deleteCategory']),

    async handleFilterSubCategory() {
      const index = this.filterOptionsSubCategory.findIndex(
        (el) => el.value === this.filterSubCategorySelected,
      );

      const text = this.filterOptionsSubCategory[index].text;
      const value = this.filterOptionsSubCategory[index].value;

      this.subCategorySelected.text = text;
      this.subCategorySelected.value = value;

      this.replaceQueryParams({
        [this.filterOptionsSubCategory[index].text]: this
          .filterSubCategorySelected,
      });

      await this.updateTable();
    },

    async getSubCategory(value) {
      this.subCategoryOptions = [
        {
          value: null,
          text: 'Selecione uma subcategoria',
        },
      ];

      const response = await api.get('/answer/categories-subcategories', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          idCategory: value,
        },
      });

      response.data.forEach((el) => {
        this.subCategoryOptions.push({
          value: el._id.toString(),
          text: el.name,
          categoryGroupId: el.categoryGroupId,
        });
      });

      this.filterOptionsSubCategory = this.subCategoryOptions;
    },

    async handleFilter() {
      this.filterValueSelected = null;
      this.filterSelectedOptions = [];

      if (this.filterSelected) {
        switch (this.filterSelected) {
          case 'category':
            if (this.myActionsIds.length !== 0) {
              this.getCategoryGroupAction(this.myActionsIds);
            } else {
              this.filterSelectedOptions = this.categoryOptions;
            }
            break;
          case 'status':
            this.getStatus();
            break;
          case 'profile':
            this.filterSelectedOptions = this.profileOptions;
            break;
          case 'responsible':
            this.filterSelectedOptions = this.responsibleOptions;
            break;
          case 'comment':
            this.filterSelectedOptions = this.commentOptions;
            break;
          case 'anonymous':
            this.filterSelectedOptions = this.anonymousOptions;
            break;
          default:
            break;
        }

        this.displayFilterOptions = true;
      } else {
        this.displayFilterOptions = false;
      }
    },

    async getCategoryGroupAction(actionId) {
      try {
        const response = await api.get('/categories-groups', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId: actionId.length === 0 ? null : actionId.join(','),
          },
        });

        const categoriesGroups = response.data;

        this.filterSelectedOptions = [
          { value: null, text: this.$t('answers.categorySelect.select') },
          { value: 'all', text: this.$t('answers.categorySelect.all') },
          { value: 'empty', text: this.$t('answers.categorySelect.empty') },
        ];

        categoriesGroups.categories.forEach((el) => {
          if (el.active === true) {
            this.filterSelectedOptions.push({
              value: el._id.toString(),
              text: el.name,
            });
          }
        });
      } catch (error) {
        window.console.log(error);
      }
    },

    async handleFilterValue() {
      if (this.filterSelected && this.filterValueSelected) {
        const index = this.filterSelectedOptions.findIndex(
          (el) => el.value === this.filterValueSelected,
        );

        const text = this.filterSelectedOptions[index].text;

        switch (this.filterSelected) {
          case 'category':
            this.categorySelected.value = this.filterValueSelected;
            this.categorySelected.text = text;

            this.getSubCategory(this.filterValueSelected);
            break;
          case 'status':
            this.statusSelect.value = this.filterValueSelected;
            this.statusSelect.text = text;
            break;
          case 'profile':
            this.profileSelect.value = this.filterValueSelected;
            this.profileSelect.text = text;
            break;
          case 'responsible':
            this.responsibleSelected.value = this.filterValueSelected;
            this.responsibleSelected.text = text;
            break;
          case 'comment':
            this.commentSelected.value = this.filterValueSelected;
            this.commentSelected.text = text;
            break;
          case 'anonymous':
            this.anonymousSelected.value = this.filterValueSelected;
            this.anonymousSelected.text = text;
            break;
          default:
            break;
        }

        this.replaceQueryParams({
          [this.filterSelected]: this.filterValueSelected,
        });

        await this.updateTable();
      }
    },

    async removeFilter(filter) {
      switch (filter) {
        case 'category':
          this.categorySelected.value = null;
          this.categorySelected.text = null;
          break;
        case 'subCategory':
          this.subCategorySelected.value = null;
          this.subCategorySelected.text = null;
          break;
        case 'status':
          this.statusSelect.value = null;
          this.statusSelect.text = null;
          break;
        case 'profile':
          this.profileSelect.value = null;
          this.profileSelect.text = null;
          break;
        case 'responsible':
          this.responsibleSelected.value = null;
          this.responsibleSelected.text = null;
          break;
        case 'comment':
          this.commentSelected.value = null;
          this.commentSelected.text = null;
          break;
        case 'anonymous':
          this.anonymousSelected.value = null;
          this.anonymousSelected.text = null;
          break;
        default:
          break;
      }

      this.replaceQueryParams({ [filter]: undefined });

      await this.updateTable();
    },

    async getStatus() {
      const response = await api.get('/treatments-status', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });

      const lang = this.$i18n.locale


      const options = response.data;


      if (lang == 'br'){
        this.filterSelectedOptions = response.data;
      } else if(lang == 'us'){

        const statusTranslate = [];
        for (let i = 0; i < options.length; i++) {
          if(options[i].text == 'Filtro por status'){
            statusTranslate.push({value: null, text: "Filter by status"})
          }
          else if(options[i].text == 'Todos'){
            statusTranslate.push({value: "all", text: "All"})
          }
          else if(options[i].text == 'Aberto'){
            statusTranslate.push({value: "aberto", text: "Openned"})
          }
          else if(options[i].text == 'Análise interno'){
            statusTranslate.push({value: "Análise interno", text: "Internal analysis"})
          }
          else if(options[i].text == 'Em análise'){
            statusTranslate.push({value: "em_analise", text: "Under review"})
          }
          else if(options[i].text == 'Escalonada'){
            statusTranslate.push({value: "escalonada", text: "Staggered"})
          }
          else if(options[i].text == 'Negada'){
            statusTranslate.push({value: "Negada", text: "Denied"})
          }
          else if(options[i].text == 'Não conforme'){
            statusTranslate.push({value: "Não conforme", text: "Non-conforming"})
          }
          else if(options[i].text == 'Respondido'){
            statusTranslate.push({value: "respondido", text: "Answered"})
          }
          else if(options[i].text == 'Respondido - Repesquisa'){
            statusTranslate.push({value: "Respondido - Repesquisa", text: "Answered Research"})
          }
          else if(options[i].text == 'Verificando internamente'){
            statusTranslate.push({value: "Verificando internamente", text: "Internally verified"})
          }
           else {
            statusTranslate.push(options[i])
          }


        }
        this.filterSelectedOptions =statusTranslate;

      } else{

        const statusTranslate = [];
        for (let i = 0; i < options.length; i++) {
          if(options[i].text == 'Filtro por status'){
            statusTranslate.push({value: null, text: "Filtrar por estado"})
          }
          else if(options[i].text == 'Todos'){
            statusTranslate.push({value: "all", text: "Todos"})
          }
          else if(options[i].text == 'Aberto'){
            statusTranslate.push({value: "aberto", text: "Abierto"})
          }
          else if(options[i].text == 'Análise interno'){
            statusTranslate.push({value: "Análise interno", text: "Análisis interno"})
          }
          else if(options[i].text == 'Em análise'){
            statusTranslate.push({value: "em_analise", text: "En análisis"})
          }
          else if(options[i].text == 'Escalonada'){
            statusTranslate.push({value: "escalonada", text: "Escalonado"})
          }
          else if(options[i].text == 'Negada'){
            statusTranslate.push({value: "Negada", text: "Denegado"})
          }
          else if(options[i].text == 'Não conforme'){
            statusTranslate.push({value: "Não conforme", text: "No conforme"})
          }
          else if(options[i].text == 'Respondido'){
            statusTranslate.push({value: "respondido", text: "Contestada"})
           }
            else if(options[i].text == 'Respondido - Repesquisa'){
            statusTranslate.push({value: "Respondido - Repesquisa", text: "Respondido - Investigacíon"})
          }
            else if(options[i].text == 'Verificando internamente'){
            statusTranslate.push({value: "Verificando internamente", text: "Verificado internamente"})

          } else {
            statusTranslate.push(options[i])
          }
      }
      this.filterSelectedOptions =statusTranslate;
    }



    },

    async updateTable() {
      this.$store.state.treatments.loading = true;

      this.pageSelected = false;
      // this.selectedAnswersIds = [];
      // this.allAnswersSelected = false;

      const response = await api.get(
        `${process.env.API_ROOT}/answers/${this.userAuth.companyId}`,
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
            page: this.page,
            limit: this.limit,
            startDate: this.calendarDates.start,
            endDate: this.calendarDates.end,
            filter: this.filter,
            ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
            ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
            sortBy: this.sortBy,
            sortDesc: this.sortDesc,
            grade: this.grade,
            metric: this.myMetric,
            profile: this.profileSelect.value,
            status: this.statusSelect.value,
            groupId: this.actionGroupData._id,
            category: this.categorySelected.value,
            subCategory: this.subCategorySelected.value,
            indicator: this.indicatorName,
            indicatorValue: this.indicatorData.value,
            indicatorRange: this.indicatorData.range,
            responsible: this.responsibleSelected.value,
            comment: this.commentSelected.value,
            anonymous: this.anonymousSelected.value,
            ignoreAnsweredStatus: true,
          },
        },
      );

      this.items = response.data.answers;
      this.total = response.data.summary.total;

      this.$store.state.treatments.loading = false;
    },

    async getCompanyCategories() {
      try {
        const response = await api.get('/categories', {
          headers: {
            'x-access-token': this.userAuth.token,
          },
          params: {
            categoryGroup: null,
          },
        });
        this.actionCategories = response.data;
      } catch (error) {
        window.console.log(error);
      }
    },

    verifyChecked(answerId) {
      const idFound = this.selectedAnswersIds.indexOf(answerId);

      this.verifyPageSelected();

      if (idFound >= 0) {
        return true;
      }

      return false;
    },

    selectAnswer(answerId, checked) {
      if (checked) {
        this.selectedAnswersIds.push(answerId);
      } else {
        this.selectedAnswersIds = this.selectedAnswersIds.filter(
          (id) => id !== answerId,
        );
      }
    },

    verifyPageSelected() {
      if (this.allAnswersSelected) {
        this.pageSelected = true;
      } else {
        const ids = this.items.filter((answer) =>
          this.selectedAnswersIds.includes(answer._id),
        );

        if (ids.length >= this.items.length) {
          this.pageSelected = true;
        } else {
          this.pageSelected = false;
        }
      }
    },

    async getTotalAnswers() {
      const response = await api.post(
        '/close-the-loop/send',
        {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          page: this.page,
          limit: this.limit,
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          filter: this.filter,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          sortBy: this.sortBy,
          sortDesc: this.sortDesc,
          grade: this.grade,
          metric: this.myMetric,
          profile: this.profileSelect.value,
          status: this.statusSelect.value,
          groupId: this.actionGroupData._id,
          category: this.categorySelected.value,
          subcategory: this.subCategorySelected.value,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          responsible: this.responsibleSelected.value,
          comment: this.commentSelected.value,
          anonymous: this.anonymousSelected.value,
          ignoreAnsweredStatus: true,
          ids: this.selectedAnswersIds,
          reviewSubmission: true,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );

      this.selectedAnswersIds = response.data.answersIds;

      this.totalAnswers = response.data.qty;
    },

    async selectAllAnswers() {
      this.allAnswersSelected = true;
      this.pageSelected = true;
      this.selectedAnswersIds = [];

      await this.getTotalAnswers();
    },

    cancelAnswersSelected() {
      this.allAnswersSelected = false;
      this.totalAnswers = 0;
      this.selectedAnswersIds = [];

      this.pageSelected = false;
    },

    selectPage(event) {
      if (event.target.checked) {
        this.items.forEach((answer) => {
          const idFound = this.selectedAnswersIds.indexOf(answer._id);

          if (idFound < 0) {
            this.selectedAnswersIds.push(answer._id);
          }
        });
      } else {
        this.items.forEach((answer) => {
          const idFound = this.selectedAnswersIds.indexOf(answer._id);

          if (idFound >= 0) {
            this.selectedAnswersIds.splice(idFound, 1);
          }
        });
      }
    },

    checkName(anonymous, name) {
      if (
        anonymous &&
        !this.userProfile.permissions.answers.anonymous_profile
      ) {
        return 'Anônimo';
      } else if (this.userProfile.permissions.answers.anonymous_profile) {
        return 'Nome: ***************';
      } else if (name) {
        return name;
      }
      return 'Sem Nome';
    },

    checkUserData(anonymous, value) {
      if (anonymous || this.userProfile.permissions.answers.anonymous_profile) {
        return '***************';
      } else if (value) {
        return value;
      }
      return '-';
    },

    replaceQueryParams(object) {
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, ...object },
      });
    },

    searchByFilter() {
      if (this.filter !== '' && this.filter !== null) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.updateTable, 600);
      }
      if (this.filter === '') {
        this.filter = null;
        this.updateTable();
      }
    },

    cleanFilter() {
      this.filter = null;
      this.updateTable();
    },

    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.updateTable();
    },

    dateFormat(param) {
      const day = lightFormat(new Date(param), 'dd/MM/yyyy');
      const hour = lightFormat(new Date(param), 'HH:mm');
      return `${day} às ${hour}`;
    },

    gradeFormat(grade) {
      if (this.myMetric === 'nps-0-10') {
        if (grade >= 9 && grade <= 10) {
          return 'promoters';
        } else if (grade === 7 || grade === 8) {
          return 'neutral';
        } else if (grade < 7) {
          return 'detractors';
        }
        return 'invalid';
      } else if (
        this.myMetric === 'nps-1-5' ||
        this.myMetric === 'ces-1-5' ||
        this.myMetric === 'csat-1-5' ||
        this.myMetric === '5-stars'
      ) {
        if (grade > 3 && grade < 6) {
          return 'promoters';
        } else if (grade === 3) {
          return 'neutral';
        } else if (grade < 3) {
          return 'detractors';
        }
        return 'invalid';
      }
      return 'invalid';
    },

    async getResponsibles() {
      const response = await api.get('treatments/responsible-users', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        },
      });

      const users = response.data;

      this.responsibleOptions.push({ value: 'none', text: 'Ninguém' })

      users.forEach((el) =>
        this.responsibleOptions.push({ value: el._id, text: el.name }),
      );
    },

    getCategoryName(id) {
      for (let i = 0; i < this.actionCategories.length; i += 1) {
        if (id === this.actionCategories[i]._id) {
          return this.actionCategories[i].name;
        }
      }
      return '';
    },

    changeFields() {
      this.fields = [
        {
          key: 'controlId',
          label: this.$t('treatments.treatmentTable.labels.id'),
        },
        {
          key: 'actionId',
          label: 'Ação',
        },
        {
          key: 'date',
          label: this.$t('treatments.treatmentTable.labels.date'),
          sortable: true,
        },
        {
          key: 'review',
          label:
            this.myMetric === 'like-dislike'
              ? 'Avaliação'
              : this.$t('treatments.treatmentTable.labels.grade'),
          sortable: true,
        },
        {
          key: 'name',
          label: this.$t('treatments.treatmentTable.labels.client'),
        },
        {
          key: 'comment',
          label: this.$t('treatments.treatmentTable.labels.comment'),
        },
        {
          key: 'category',
          label: this.$t('treatments.treatmentTable.labels.category'),
        },
        {
          key: 'select',
          label: this.$t('closetheloop.selectAnswers.selectLabel'),
        },
      ];
    },

    changeLabels() {
      this.filterOptions = [
        { value: null, text: this.$t('answers.filterOptions.select') },
        { value: 'profile', text: this.$t('answers.filterOptions.profile') },
        { value: 'status', text: this.$t('answers.filterOptions.status') },
        { value: 'category', text: this.$t('answers.filterOptions.category') },
        {
          value: 'responsible',
          text: this.$t('answers.filterOptions.responsible'),
        },
        {
          value: 'comment',
          text: this.$t('answers.filterOptions.comments'),
        },
        {
          value: 'anonymous',
          text: this.$t('answers.filterOptions.anonymous'),
        },
      ];

      let promotersText = '';
      let passivesText = '';
      let detractorsText = '';

      if (this.myMetric.indexOf('nps') >= 0) {
        promotersText = this.$t('answers.profileSelect.promoters');
        passivesText = this.$t('answers.profileSelect.neutral');
        detractorsText = this.$t('answers.profileSelect.detractors');
      } else if (
          this.myMetric.indexOf('ces') >= 0 ||
          this.myMetric.indexOf('stars') >= 0
        ) {
        promotersText = '5-4';
        passivesText = '3';
        detractorsText = '2-1';
      } else if (this.myMetric.indexOf('csat') >= 0) {
        promotersText = '5-4';
        passivesText = '3';
        detractorsText = '2-1';
      } else if ( this.myMetric.indexOf('like-dislike') >= 0 ) {
        promotersText = 'Like';
        detractorsText = 'Dislike';
      }

      this.profileOptions = [
        { value: null, text: this.$t('answers.profileSelect.select') },
        { value: 'all', text: this.$t('answers.profileSelect.all') },
        { value: 'detractors', text: detractorsText },
        { value: 'passives', text: passivesText },
        { value: 'promoters', text: promotersText },
      ];

      if(this.myMetric.indexOf('like-dislike') >= 0) {
        this.profileOptions.splice(3, 1);
      }

      this.categoryOptions = [
        { value: null, text: this.$t('answers.categorySelect.select') },
        { value: 'all', text: this.$t('answers.categorySelect.all') },
      ];

      this.statusOptions = [
        { value: null, text: this.$t('treatments.statusSelect.select') },
        { value: 'all', text: this.$t('treatments.statusSelect.all') },
        {
          value: 'respondido',
          text: this.$t('treatments.statusSelect.answered'),
        },
        {
          value: 'em_analise',
          text: this.$t('treatments.statusSelect.analysis'),
        },
        {
          value: 'escalonada',
          text: this.$t('treatments.statusSelect.staggered'),
        },
        { value: 'aberto', text: this.$t('treatments.statusSelect.opened') },
      ];

      this.responsibleOptions = [
        { value: null, text: this.$t('answers.responsibleSelect') },
      ];
      this.commentOptions = [
        { value: null, text: this.$t('answers.commentsSelect.select') },
        { value: 'all', text: this.$t('answers.commentsSelect.all') },
        {
          value: 'withComments',
          text: this.$t('answers.commentsSelect.withComments'),
        },
        {
          value: 'noComments',
          text: this.$t('answers.commentsSelect.noComments'),
        },
      ];
      this.anonymousOptions = [
        { value: null, text: this.$t('answers.anonymousSelect.select') },
        { value: 'all', text: this.$t('answers.anonymousSelect.all') },
        {
          value: 'false',
          text: this.$t('answers.anonymousSelect.no'),
        },
        {
          value: 'true',
          text: this.$t('answers.anonymousSelect.yes'),
        },
      ];

      this.fields = [
        {
          key: 'controlId',
          label: this.$t('treatments.treatmentTable.labels.id'),
        },
        {
          key: 'actionId',
          label: 'Ação',
        },
        {
          key: 'date',
          label: this.$t('treatments.treatmentTable.labels.date'),
          sortable: true,
        },
        {
          key: 'review',
          label: this.$t('treatments.treatmentTable.labels.grade'),
          sortable: true,
        },
        {
          key: 'name',
          label: this.$t('treatments.treatmentTable.labels.client'),
        },
        {
          key: 'comment',
          label: this.$t('treatments.treatmentTable.labels.comment'),
        },
        {
          key: 'category',
          label: this.$t('treatments.treatmentTable.labels.category'),
        },
        {
          key: 'select',
          label: this.$t('closetheloop.selectAnswers.selectLabel'),
        },
      ];
    },

    handleNextStep() {
      let startDate = null;
      let endDate = null;
      let ih1Label = null;
      let ih2Label = null;
      let groupLabel = null;

      if (this.selected === 'email') {
        if (this.selectedAnswersIds.length <= 0 && !this.allAnswersSelected) {
          swal(
            'Oops...',
            this.$t('closetheloop.selectAnswers.validationText'),
            'error',
          );
          return;
        }

        if (this.calendarDates.start) {
          const [year, month, day] = this.calendarDates.start.split('-');
          startDate = `${day}/${month}/${year}`;
        }

        if (this.calendarDates.end) {
          const [year, month, day] = this.calendarDates.end.split('-');
          endDate = `${day}/${month}/${year}`;
        }

        if (this.myIh1 !== '0') {
          const item = this.ih1.listFilters.find(
            (obj) => obj._id === this.myIh1,
          );
          ih1Label = item.corporate_name;
        }

        if (this.myIh2 !== '0') {
          const item = this.ih2.listFilters.find(
            (obj) => obj._id === this.myIh2,
          );
          ih2Label = item.corporate_name;
        }

        if (this.actionGroupData._id) {
          groupLabel = this.actionGroupData.name;
        }

        this.$emit('input', {
          ids: this.selectedAnswersIds,
          all: this.allAnswersSelected,
          filtersSelected: {
            actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
            startDate: this.calendarDates.start,
            endDate: this.calendarDates.end,
            filter: this.filter,
            ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
            ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
            metric: this.myMetric,
            profile: this.profileSelect.value,
            status: this.statusSelect.value,
            groupId: this.actionGroupData._id,
            category: this.categorySelected.value,
            subcategory: this.subCategorySelected.value,
            indicator: this.indicatorName,
            indicatorValue: this.indicatorData.value,
            indicatorRange: this.indicatorData.range,
            responsible: this.responsibleSelected.value,
            comment: this.commentSelected.value,
            anonymous: this.anonymousSelected.value,
          },
          reviewInfo: {
            actionName: this.$store.state.actions.myActionName,
            startDate,
            endDate,
            searchField: this.filter,
            ih1: ih1Label,
            ih2: ih2Label,
            metric: this.myMetric,
            profile: this.profileSelect.text,
            status: this.statusSelect.text,
            groupName: groupLabel,
            category: this.categorySelected.text,
            subcategory: this.subCategorySelected.value,
            indicatorValue: this.indicatorData.text,
            indicatorRange: this.indicatorData.range,
            responsible: this.responsibleSelected.text,
            comment: this.commentSelected.value,
            anonymous: this.anonymousSelected.value,
          },
        });

        this.showModal = false;

        this.step += 1;
      } else {
        this.showModal = true;
      }
    },

    async getStatusModal() {
      const response = await api.get('/treatments/status', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          lang: this.$i18n.locale,
        },
      });

      this.optionsStatus = response.data;
    },

    async makeDealings() {
      if (this.status) {
        if (this.selectedAnswersIds.length === 0) {
          swal(
            this.$t('closetheloop.selectAnswers.swal.noReply.title'),
            this.$t('closetheloop.selectAnswers.swal.noReply.description'),
            'warning',
          );
        } else {
          swal({
            title: this.$t(
              'closetheloop.selectAnswers.swal.confirmAction.title',
            ),
            text: this.$t(
              'closetheloop.selectAnswers.swal.confirmAction.description',
            ),
            icon: 'warning',
            buttons: ['Não', 'Sim'],
          }).then(async (yes) => {
            if (yes) {
              await api.patch(
                '/close-the-loop/status',
                {
                  answersIds: this.selectedAnswersIds,
                  comment: this.comment,
                  status: this.status,
                  userId: this.responsibleModal
                },
                {
                  headers: {
                    'x-access-token': this.userAuth.token,
                  },
                },
              );

              this.comment = null;
              this.status = null;

              swal(
                this.$t('closetheloop.selectAnswers.swal.success.title'),
                this.$t('closetheloop.selectAnswers.swal.success.description'),
                'success',
              );
            }
          });
        }
      } else {
        swal(
          this.$t('closetheloop.selectAnswers.swal.selectStatus.title'),
          this.$t('closetheloop.selectAnswers.swal.selectStatus.description'),
          'warning',
        );
      }
    },
  },

  watch: {
    actionGroupData: function watchActionGroup() {
      this.page = 1;
      this.updateTable();
    },

    myActionId: function watchmyActionId() {
      this.page = 1;
      this.updateTable();
    },

    myActionsIds: function watchmyActionsIds() {
      this.page = 1;
      this.updateTable();
    },

    calendarDates: function watchCalendarDates() {
      this.page = 1;
      this.updateTable();
    },

    myIh1: function watchMyIh1() {
      this.page = 1;
      this.updateTable();
    },

    myHierarchies1: function watchMyHierarchies1() {
      this.page = 1;
      this.updateTable();
    },

    myIh2: function watchMyIh2() {
      this.page = 1;
      this.updateTable();
    },

    myHierarchies2: function watchMyHierarchies2() {
      this.page = 1;
      this.updateTable();
    },

    myMetric: function watchMyMetric() {
      this.page = 1;
      this.updateTable();
      this.changeLabels();
      this.changeFields();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.page = 1;
      this.updateTable();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      this.page = 1;
      this.updateTable();
    },

    '$i18n.locale': function watchLocale() {
      this.changeLabels();
    },

    submitDone: function watchSubmitDone(value) {
      if (value) {
        this.pageSelected = false;
        this.selectedAnswersIds = [];
        this.allAnswersSelected = false;
      }
    },

    selected: function watchSelectedRadio(value) {
      if (value === 'email') {
        this.showModal = false;
      } else {
        this.showModal = true;
        this.getStatusModal();
      }
    },
  },

  mounted() {
    this.changeFields();
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.responsibleModal = this.userAuth._id;

    this.changeFields();

    this.radioOptions = [
      {
        item: 'email',
        name: this.$t('closetheloop.selectAnswers.byEmail'),
      },
      {
        item: 'status',
        name: this.$t('closetheloop.selectAnswers.onlyStatus'),
      },
    ];

    EventBus.$on('changedAction', () => {
      this.handleFilter();
    });

    EventBus.$on('resetFilterCategory', () => {
      this.filterSelected = null;
      this.filterValueSelected = null;
      this.displayFilterOptions = false;
    });

    this.$store.state.treatments.loading = false;

    this.submitDone = false;

    this.changeLabels();

    await Promise.all([this.getCompanyCategories()], this.getResponsibles());

    this.actionCategories.forEach((el) => {
      if (el.active === true) {
        this.options.push(el);

        this.categoryOptions.push({
          value: el._id.toString(),
          text: el.name,
        });
      }
    });

    if (parseInt(this.$route.query.grade, 10) + 1) {
      this.grade = this.$route.query.grade;
    }

    if (this.$route.query.profile) {
      const index = this.profileOptions.findIndex(
        (el) => el.value === this.$route.query.profile,
      );

      if (index >= 0) {
        this.profileSelect.value = this.profileOptions[index].value;
        this.profileSelect.text = this.profileOptions[index].text;
      }
    }

    if (this.$route.query.category) {
      const index = this.categoryOptions.findIndex(
        (el) => el.value === this.$route.query.category,
      );

      if (index >= 0) {
        this.categorySelected.value = this.categoryOptions[index].value;
        this.categorySelected.text = this.categoryOptions[index].text;
      }
    }

    if (this.$route.query.status) {
      const index = this.statusOptions.findIndex(
        (el) => el.value === this.$route.query.status,
      );

      if (index >= 0) {
        this.statusSelect.value = this.statusOptions[index].value;
        this.statusSelect.text = this.statusOptions[index].text;
      }
    }

    if (this.$route.query.responsible) {
      const index = this.responsibleOptions.findIndex(
        (el) => el.value === this.$route.query.responsible,
      );

      if (index >= 0) {
        this.responsibleSelected.value = this.responsibleOptions[index].value;
        this.responsibleSelected.text = this.responsibleOptions[index].text;
      }
    }
    if (this.$route.query.comment) {
      const index = this.commentOptions.findIndex(
        (el) => el.value === this.$route.query.comment,
      );

      if (index >= 0) {
        this.commentSelected.value = this.responsibleOptions[index].value;
        this.commentSelected.text = this.responsibleOptions[index].text;
      }
    }

    this.updateTable();
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.thumbs-up-answer {
  color: #64b64d;
  font-size: 40px;
}

.thumbs-down-answer {
  color: red;
  font-size: 40px;
}

.select-all-area {
  display: flex;
  justify-content: center;
  align-items: center;

  .select-all-description {
    padding: 10px 30px;
    color: #5f6368;
    background-color: rgba(241, 243, 244, 0.6);
  }

  .link {
    color: #1a73e8;
    cursor: pointer;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.switch-box {
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.switch-box span {
  font-size: 16px;
}

.search-answers {
  display: flex;
  flex-direction: row;

  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}

.filters-area {
  display: flex;
  flex-direction: row;

  .tag {
    background: $primary;
    padding: 4px 8px;
    color: $white;
    border-radius: 8px;
    margin-right: 8px;

    .remove {
      cursor: pointer;
    }
  }
}

.flag-category-close {
  cursor: pointer;
  &:hover {
    color: rgb(240, 235, 235);
  }
}

a {
  cursor: pointer;
}

.flag-category-text {
  text-transform: lowercase;
}

.table-icons {
  color: $primary;
  padding-left: 25px;
  font-size: 20px;
  svg {
    &:hover {
      color: #46b41e;
    }
  }
}

.user-info {
  color: rgb(133, 131, 131);
}

.flag-grade {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: $white;
  font-weight: bold;
}
.footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.flag-grade-promoters {
  background-color: #28a745;
}
.flag-grade-detractors {
  background-color: #dc3545;
}
.flag-grade-neutral {
  background-color: rgb(211, 211, 17);
}
.flag-grade-invalid {
  background-color: #c1c1c1;
}
.edit-comment-area {
  display: flex;
  flex-direction: row;
}
.pagination-area-answers >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>

<style>
.pagination-area-answers .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}
.pagination-area-answers a {
  outline: none;
}

textarea {
  resize: none;
}

.data-filter {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/closetheloop/select-answers/index.vue